/**
 * A failed save of a good or a buyer, in words for the person (507). The server's own Persian sentence is kept; an
 * exception's English text («An error has occurred.», «Network Error») never reaches the dialog, ours does instead.
 */

const hasPersianLetters = (text: string) => /[؀-ۿ]/.test(text)

const toRecord = (value: unknown): Record<string, unknown> | undefined =>
  typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : undefined

const persianText = (value: unknown) =>
  typeof value === 'string' && value.trim() && hasPersianLetters(value) ? value.trim() : undefined

export const CATALOG_CONNECTION_ERROR =
  'ارتباط با سرور برقرار نشد. اتصال اینترنت را بررسی کنید و دوباره تلاش کنید.'

// The request may have reached the server: the person looks at the list before saving again, or a new good or buyer
// could be added twice.
export const CATALOG_TIMEOUT_ERROR =
  'پاسخ سرور به‌موقع نرسید. پیش از ذخیره دوباره، فهرست را بازخوانی کنید و ببینید تغییر ثبت شده است یا نه.'

export const CATALOG_FORBIDDEN_ERROR = 'دسترسی لازم برای این تغییر را ندارید.'

export const readCatalogSaveError = (error: unknown, fallback: string): string => {
  const failure = toRecord(error)
  const response = toRecord(failure?.response)
  const status = typeof response?.status === 'number' ? response.status : undefined

  if (failure?.code === 'ECONNABORTED' || status === 408 || status === 504) {
    return CATALOG_TIMEOUT_ERROR
  }

  if (!response) {
    // An error the form raised itself carries its own Persian sentence; a request without an answer did not connect.
    const ownMessage = persianText(failure?.message)
    if (ownMessage) return ownMessage
    return failure?.isAxiosError || failure?.request ? CATALOG_CONNECTION_ERROR : fallback
  }

  const data = response.data
  const payload = toRecord(data)
  const serverMessage =
    persianText(data) ||
    persianText(payload?.Message) ||
    persianText(payload?.message) ||
    persianText(payload?.ExceptionMessage)
  if (serverMessage) return serverMessage

  if (status === 403) return CATALOG_FORBIDDEN_ERROR
  return fallback
}
